/**
 * Lenis smooth scroll (https://github.com/darkroomengineering/lenis)
 * Replaces the previous same-page-anchor-only scroller.
 * Wheel/trackpad is smoothed; native touch scroll is left as-is.
 */
(function () {
  if (window.Shopify && Shopify.designMode) {
    return;
  }

  if (typeof Lenis === 'undefined') {
    return;
  }

  window.nwLenis = new Lenis({
    autoRaf: true,
    autoToggle: true,
    anchors: true,
    allowNestedScroll: true,
    naiveDimensions: true,
    stopInertiaOnNavigate: true,
    lerp: 0.1,
    prevent: function (node) {
      if (!node || !node.classList) return false;

      return (
        node.hasAttribute('data-lenis-prevent') ||
        node.classList.contains('drawer') ||
        node.classList.contains('modal') ||
        node.classList.contains('pswp') ||
        node.classList.contains('quick-view') ||
        node.classList.contains('quick-view-modal') ||
        node.classList.contains('cart-drawer')
      );
    },
  });

  document.dispatchEvent(new CustomEvent('nw:lenis-ready'));
})();
